import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ProfilePictureUpload from '../ProfilePictureUpload';
import InfluencerContent from './components/InfluencerContent';
import InfluencerInfo from './components/InfluencerInfo';
import { countries } from '../../../constants';
import enhance from './InfluencerSignUp.enhancer';
import HpTooltip from '../../../components/shared/components/hpTooltip';

const steps = ['Profile Picture', 'About', 'Content'];

class InfluencerSignup extends React.Component {
  constructor() {
    super();

    this.initialState = {
      activeStep: 0,
      profileWasLoaded: false,
      influencerInfo: {
        description: '',
        audience: '',
        age: '',
        rating: 0,
        signUpComplete: true,
        interests: [],
        displayName: '',
        country: '',
        industry: '',
        gender: ''
      },
      customEmail: '',
      countries: countries
    };

    this.state = {
      ...this.initialState
    };
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.profile.isLoaded &&
      (newProps.profile.signUpComplete ||
        newProps.profile.signUpComplete === undefined)
    ) {
      this.setState({ ...this.initialState });
      this.props.history.push('/dashboard');
    } else if (
      newProps.profile &&
      newProps.profile.isLoaded &&
      !this.state.profileWasLoaded
    ) {
      this.setState({
        profileWasLoaded: true,
        influencerInfo: {
          ...this.state.influencerInfo,
          displayName: newProps.profile.displayName
        }
      });
    }
  }

  getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <React.Fragment>
            <Typography
              component="h3"
              variant="h5"
              align="center"
              className={this.props.classes.proPictureText}
            >
              First let's set up your profile picture
            </Typography>
            <HpTooltip
              styling={{
                marginLeft: '5px',
                marginBottom: '3px'
              }}
              message={
                'This is the picture companies will see when they go to your profile. Upload any image below 2MB.'
              }
            />
            <ProfilePictureUpload />
            <div className={this.props.classes.buttons}>
              <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  this.setState(state => ({
                    activeStep: state.activeStep + 1
                  }))
                }
                className={this.props.classes.nextButton}
              >
                Next
              </Button>
            </div>
          </React.Fragment>
        );
      case 1:
        return (
          <InfluencerInfo
            changeHandler={this.handleInfluencerInfoChange}
            customEmailChangeHandler={this.handleCustomEmailChangeHandler}
            customEmail={this.state.customEmail}
            displayName={this.props.profile.displayName}
            country={this.state.influencerInfo.country}
            countries={this.state.countries}
            gender={this.state.influencerInfo.gender}
            age={this.state.influencerInfo.age}
            handleBackClick={this.handleBack}
            handleNextClick={this.handleNext}
          />
        );
      case 2:
        return (
          <InfluencerContent
            changeHandler={this.handleInfluencerInfoChange}
            interestChange={this.handleInterestChange}
            description={this.state.influencerInfo.description}
            audience={this.state.influencerInfo.audience}
            interests={this.state.influencerInfo.interests}
            industry={this.state.influencerInfo.industry}
            handleBackClick={this.handleBack}
            handleFinishClick={this.handleSaveProfile}
          />
        );
      default:
        throw new Error('Unknown step');
    }
  }

  getHeaderContent(step, displayName) {
    switch (step) {
      case 0:
        return `Welcome aboard ${displayName}, let's set up your profile!`;
      case 1:
        return `${displayName}, tell us a little more about yourself`;
      case 2:
        return `${displayName}, please describe your content`;
      default:
        throw new Error('Unknown step');
    }
  }

  handleNext = () => {
    this.setState(state => ({
      activeStep: state.activeStep + 1
    }));
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0
    });
  };

  handleInfluencerInfoChange = e => {
    this.setState({
      influencerInfo: {
        ...this.state.influencerInfo,
        [e.target.name]:
          e.target.name === 'age'
            ? Number.parseInt(e.target.value)
            : e.target.value
      }
    });
  };

  handleInterestChange = chips => {
    this.setState({
      influencerInfo: {
        ...this.state.influencerInfo,
        interests: chips
      }
    });
  };

  handleCustomEmailChangeHandler = e => {
    this.setState({
      customEmail: e.target.value
    });
  };

  handleSaveProfile = () => {
    const country = find(
      this.state.countries,
      country => country.value === this.state.influencerInfo.country
    );

    this.props.saveProfile({
      ...this.state.influencerInfo,
      email: this.state.customEmail
        ? this.state.customEmail
        : this.props.profile.email,
      country: country ? country.key : 'All'
    });
  };

  render() {
    const { classes, auth, profile } = this.props;
    const { activeStep, influencerInfo } = this.state;

    return (
      <React.Fragment>
        <CssBaseline />
        {profile.isLoaded && (
          <main className={classes.layout}>
            <Paper className={classes.paper}>
              <Typography
                component="h1"
                variant="h4"
                align="center"
                className={this.props.classes.signupTitle}
              >
                {this.getHeaderContent(activeStep, profile.displayName)}
              </Typography>
              <Stepper activeStep={activeStep} className={classes.stepper}>
                {steps.map(label => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <React.Fragment>{this.getStepContent(activeStep)}</React.Fragment>
            </Paper>
          </main>
        )}
      </React.Fragment>
    );
  }
}

InfluencerSignup.propTypes = {
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object,
  profile: PropTypes.object,
  router: PropTypes.object,
  saveProfile: PropTypes.func
};

export default enhance(InfluencerSignup);



// WEBPACK FOOTER //
// ./src/components/sign-up/influencer/InfluencerSignUp.js